import React from "react";
import StatusPill from "@/components/StatusPill";

function MetaItem({ label, value }) {
  if (!value) return null;
  return (
    <div className="space-y-1">
      <div className="text-[11px] font-sans font-bold uppercase tracking-[0.2em] text-npst-gold">{label}</div>
      <div className="text-sm font-sans font-semibold text-npst-ink">{value}</div>
    </div>
  );
}

export default function PilHero({ pil }) {
  const num = String(pil.seq ?? 1).padStart(2, "0");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16" data-testid="pil-hero">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start relative">
        {/* LEFT */}
        <div className="lg:col-span-4 space-y-6 pb-8 lg:pb-0 lg:pr-10 lg:border-r border-npst-line">
          <div className="font-serif text-7xl sm:text-8xl lg:text-9xl font-light text-npst-goldBorder select-none leading-none -mb-3 tracking-tighter">
            {num}
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-npst-ink leading-[1.15] tracking-tight" data-testid="pil-title">
            {pil.title}
          </h1>
          <div className="space-y-5 pt-5 border-t border-npst-line">
            <MetaItem label="Court" value={pil.court} />
            <MetaItem label="Case No." value={pil.case_number} />
            <div className="space-y-1.5">
              <div className="text-[11px] font-sans font-bold uppercase tracking-[0.2em] text-npst-gold">Status</div>
              <StatusPill status={pil.status} />
            </div>
            <MetaItem label="Date of Filing" value={pil.filing_date} />
            <MetaItem label="Bench / Judges" value={pil.bench} />
            <MetaItem label="Petitioner" value={pil.petitioner} />
            {pil.respondents?.length > 0 && (
              <MetaItem label="Respondents" value={pil.respondents.join("; ")} />
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="lg:col-span-8 space-y-10 lg:pl-4">
          {pil.cause_of_action && (
            <section data-testid="pil-cause-of-action">
              <div className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-npst-gold mb-3">Cause of Action</div>
              <p className="text-lg font-sans text-npst-inkSoft leading-relaxed border-l-2 border-npst-gold pl-5 py-1 bg-npst-goldLight/40 rounded-r-md">
                {pil.cause_of_action}
              </p>
            </section>
          )}
          {pil.decision_status && (
            <section data-testid="pil-decision-status">
              <div className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-npst-navy mb-3">Decision / Present Status</div>
              <div className="prose-npst text-base leading-relaxed text-npst-inkSoft">
                {pil.decision_status.split("\n").filter(Boolean).map((p, i) => <p key={i} className="font-serif text-xl leading-relaxed text-npst-ink">{p}</p>)}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
